module.exports = __webpack_public_path__ + "img/6f_l_okura.fe2ea7c7.jpg";